import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import { FormattedMessage, useIntl } from 'react-intl';

import s from './PinPageModal.module.scss';
import classNames from 'classnames';

const PinPageModal = ({ show, onHide, onSave, initialTitle }) => {
    const [title, setTitle] = useState(initialTitle || '');
    const intl = useIntl();

    useEffect(() => {
        setTitle(initialTitle || '');
    }, [initialTitle, show]);

    const handleSave = () => {
        onSave(title);
        onHide();
    };

    return (
        <Modal show={show} onHide={onHide} centered contentClassName={s.modalContent}>
            <Modal.Header closeButton className={s.modalHeader}>
                <Modal.Title>
                    <FormattedMessage id="pinPage.title" defaultMessage="Pin Page" />
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className={s.modalBody}>
                <Form.Group controlId="pinTitle">
                    <Form.Label>
                        <FormattedMessage id="pinPage.linkTitle" defaultMessage="Link Title" />
                    </Form.Label>
                    <Form.Control
                        type="text"
                        placeholder={intl.formatMessage({ id: 'pinPage.enterTitle', defaultMessage: 'Enter title' })}
                        value={title}
                        onChange={(e) => setTitle(e.target.value)}
                        autoFocus
                        maxLength={40}
                    />
                </Form.Group>
            </Modal.Body>
            <Modal.Footer className={s.modalFooter}>
                <Button variant="light" onClick={onHide} className={s.cancelButton}>
                    <FormattedMessage id="general.cancel" defaultMessage="Cancel" />
                </Button>
                <Button variant="primary" onClick={handleSave} disabled={!title.trim()} className={s.saveButton}>
                    <FormattedMessage id="general.save" defaultMessage="Save" />
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

PinPageModal.propTypes = {
    show: PropTypes.bool.isRequired,
    onHide: PropTypes.func.isRequired,
    onSave: PropTypes.func.isRequired,
    initialTitle: PropTypes.string
};

export default PinPageModal;
